import { useTranslation } from "react-i18next";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { EditIcon, IConReSend, SharedButton, StyledSignUp } from "@components";
import { TIME_RESEND } from "@configs";
import { selectMerchant } from "@redux";
import { useWindowDimensions } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";

interface IProps {
    handleChangeOtp: (values: string) => void;
    handleVerifyOtp: (outotp: string) => void;
    otp: string;
    handleResend: () => void;
    timeResend: number;
}

export const ComponentSignUpOTP = (props: IProps) => {
    //page props
    const { handleChangeOtp, otp, handleVerifyOtp, handleResend, timeResend } = props;
    //page hook
    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    //page variable

    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode;
    const merchant = useSelector(selectMerchant);
    const phoneNumber = window.sessionStorage.getItem("phoneNumber") || "";
    const margin = width <= 380 ? (width <= 340 ? "0.1rem" : "0.3rem") : "0.5rem";
    const [isLoading, setIsloading] = useState(true);

    const checkWidth = width < 380 ? (width < 350 ? "2.3rem" : "2.5rem") : "3rem";

    useEffect(() => {
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
    });

    return (
        <StyledSignUp>
            <StyledContainer color={themeMode === "dark" ? "white" : "black"}>
                <div className="login-signup">{t("page.login_sign_up")}</div>
                <div className="logo-image">
                    <Skeleton loading={isLoading} avatar active title={false} paragraph={false}>
                        {<img src={merchant?.themes?.logoSmallUrl} />}
                    </Skeleton>
                </div>
                <div className="title_auth text-sub-header">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 132 }}
                    >
                        {merchant?.name ? merchant?.name : ""}
                    </Skeleton>
                </div>
                <div className="label-otp text-sub-header">
                    {t("page.please_enter_OTP_from_your_SMS")}
                </div>
                <div className="phone">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 132 }}
                    >
                        <p
                            className="phone-color"
                            style={{ color: themes?.themeColor || "#f4394f" }}
                        >
                            {phoneNumber}
                        </p>
                    </Skeleton>
                    <p className="edit" onClick={() => history.back()}>
                        <EditIcon color={themeMode === "dark" ? "white" : "#676767"} />{" "}
                        {t("page.edit")}
                    </p>
                </div>
                <OtpInput
                    numInputs={6}
                    inputStyle={{
                        width: checkWidth,
                        height: "3rem",
                        margin: `1rem ${margin}`,
                        fontSize: "1rem!important",
                        borderRadius: "4px",
                        border: "1px solid #e1e1e1",
                        background: "inherit",
                        color: "#000!important",
                        // color: `${themeMode === "dark" ? "white" : "dark"}`,
                    }}
                    containerStyle={{
                        justifyContent: "center",
                        flexWrap: "wrap",
                        margin: "1rem 0 1rem 0",
                    }}
                    isInputNum
                    onChange={handleChangeOtp}
                    value={otp}
                />
                <div className="resend text-body">
                    {timeResend === TIME_RESEND ? <IConReSend /> : timeResend}
                    <span onClick={handleResend}>{t("page.resend_OTP")}</span>
                </div>
                <StyledButton
                    className="btn-text"
                    size="large"
                    bg_color={themes?.themeColor!}
                    onClick={() => handleVerifyOtp(otp)}
                >
                    {t("page.next")}
                </StyledButton>
            </StyledContainer>
        </StyledSignUp>
    );
};

const StyledButton = styled(SharedButton)`
    margin-top: 16px;
`;

const StyledContainer = styled.div<{ color?: string }>`
    .title {
        font-style: normal;
        line-height: 27px;
        color: inherit;
        margin-bottom: 46px;
    }
    .resend {
        cursor: pointer;
        span {
            display: inline-block;
            margin-left: 8px;
            font-style: normal;
            line-height: 21px;
            /* color: #676767; */
            color: ${(p) => (p.color === "white" ? "white" : "#676767")};
            position: relative;
            top: 2px;
        }
    }
    .login-signup {
        font-weight: 500;
        font-size: 26px;
        line-height: 35px;
        text-align: center;
        color: inherit;
        margin-bottom: 20px;
        color: ${(p) => p.color};
    }
    .logo-image {
        width: 120px;
        align-items: center;
        margin: auto;
        img {
            width: 120px;
            height: auto;
            border-radius: 60px;
        }
        .ant-skeleton {
            .ant-skeleton-header {
                padding-right: 0;
                span {
                    width: 120px !important;
                    height: 120px;
                    margin-bottom: 15px;
                }
            }
        }
    }
    .title_auth {
        .ant-skeleton {
            .ant-skeleton-paragraph {
                li {
                    margin: 0 auto;
                    height: 10px;
                    border-radius: 16px;
                    margin-bottom: 12px;
                }
            }
        }
    }
    .label-sginup {
        /* font-family: "Nunito"; */
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
        margin-bottom: 32px;
    }
    .label-otp {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
    }
    .phone {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 4px;
        margin-top: 10px;
        .edit {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            /* color: #676767; */
            color: ${(p) => (p.color === "white" ? "white" : "#676767")};
            cursor: pointer;
        }
        .ant-skeleton {
            display: inline-block;
            width: auto !important;
            .ant-skeleton-content {
                display: inline-block;
                width: auto !important;
                .ant-skeleton-paragraph {
                    display: inline-block;
                    margin-top: 5px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                        margin-right: 15px;
                    }
                }
            }
        }
    }
    input {
        color: #000;
    }
`;
